import { createAsyncThunk } from "@reduxjs/toolkit";
import { iStateMessage } from "@/customTypes/GenericReduxTypes";
import { iGenericResponse } from "@/customTypes/CommonServiceTypes";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { fbCreativeSetup } from "@/services/api/cresivoxServer";


import { REDUCER_NAME, IFacebookCreativeCreateDTO } from './Types';
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const addfacebookCreative = createAsyncThunk<
	any,
	IFacebookCreativeCreateDTO,
	{ rejectValue: iStateMessage }
>(
	curriedGetThunkName("addfacebookCreative"),
	async (payload, { rejectWithValue }) => {
		try {
			const response = await fbCreativeSetup.createfacebookCreative(payload);

			if (!response) {
				return rejectWithValue({ message: "No response received" });
			}


			const { httpStatusCode, data, message } = response;

			// data.data.id is the actual ID
			const creativeId = data?.data?.id;

			if (httpStatusCode === 200 && creativeId) {
				return {
					data: {
						id: creativeId,
					},
					message: "creative created successfully",
				};
			}

			return rejectWithValue({
				httpStatusCode,
				message: message || "Unknown error",
			});

		} catch (error) {

			return rejectWithValue({
				message: "Something went wrong",
			});
		}
	}
);



export const getfacebookCreativeList = createAsyncThunk<
	iGenericResponse<any | null> | null,
	void,
	{
		rejectValue: iStateMessage;
	}
>(
	curriedGetThunkName("getfacebookCreativeList"),
	// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
	async (arg, { rejectWithValue }) => {
		try {
			const response = await fbCreativeSetup.getfacebookCreative();
			if (response) {
				const { httpStatusCode, data, message } = response;

				switch (httpStatusCode) {
					case httpStatusCodes.SUCCESS_OK: {
						if (data && data.data) {
							return {
								data: {
									httpStatusCode,
									data: data.data,
									message,
								}
							};
						} else {
							return rejectWithValue({
								httpStatusCode,
								message,
							});
						}
					}
					default: {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
			} else {
				return rejectWithValue({
					message: "No response received",
				});
			}
		} catch (error) {
			return rejectWithValue({
				message: "Something went wrong",
			});
		}
	},
);








